import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { IRecipe } from "../../sdk/types";
import { recipes } from "../../sdk/utils/api";

export interface IUsePublishRecipeMutationParameters {
    id: string;
}

export const usePublishRecipe = (
    invalidQueryKeys: string | string[],
): UseMutationResult<IRecipe, unknown, IUsePublishRecipeMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IRecipe, unknown, IUsePublishRecipeMutationParameters>({
        mutationFn: (parameters: IUsePublishRecipeMutationParameters) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot publish recipe without authorization token.",
                );
            }

            return recipes.Recipe.publish({ ...parameters, token: auth.token });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
